export const CATEGORIES = {
  lago: {
    id: "lago",
    name: "FodindinLago",
    subtitle: "Accès libre & convivial",
    tagline: "Libres & Connectés",
    description:
      "L'espace ouvert à tous. Rencontres simples, ambiance chaleureuse et bonne humeur garantie, du Plateau à Yopougon.",
    target: "Grand public, étudiants, jeunes actifs",
    pricing: "Accès libre · Bas prix",
    badge: "Populaire & Accessible",
    image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_fodindin-preview-1/artifacts/p9errcxm_FodindinLago.png",
    color: "#E05638",
    colorSoft: "rgba(224,86,56,0.12)",
    number: "01",
  },
  love: {
    id: "love",
    name: "FodindinLove",
    subtitle: "Rencontres exigeantes",
    tagline: "L'Amour Vrai",
    description:
      "Pour les hommes et femmes exigeants qui cherchent une relation sérieuse, sincère et durable. Ici, on construit.",
    target: "Célibataires sérieux et engagés",
    pricing: "Abonnement standard",
    badge: "Romance & Sérieux",
    image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_fodindin-preview-1/artifacts/zre78wyh_FodindinLove.png",
    color: "#0A5C36",
    colorSoft: "rgba(10,92,54,0.12)",
    number: "02",
  },
  vip: {
    id: "vip",
    name: "FodindinClubVIP",
    subtitle: "Prestige & Luxe",
    tagline: "Luxe & Exclusivité",
    description:
      "Le cercle premium. Discrétion absolue, profils triés sur le volet et expériences d'exception pour membres d'élite.",
    target: "Cadres, entrepreneurs, cercles restreints",
    pricing: "Abonnement premium luxe",
    badge: "Exclusivité & Confidentialité",
    image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_fodindin-preview-1/artifacts/ddbvwl82_FodindinClubVIP.png",
    color: "#D4AF37",
    colorSoft: "rgba(212,175,55,0.14)",
    number: "03",
  },
};

/**
 * Rubriques proposées à l'abonnement : les 3 catégories de profil + FodindinAir-Bengue
 * (rubrique d'annonces à l'étranger, qui n'est pas une catégorie de profil).
 */
export const CATEGORIES_ABONNEMENT = {
  ...CATEGORIES,
  air: {
    id: "air",
    name: "FodindinAir-Bengue",
    subtitle: "Annonceurs à l'étranger",
    tagline: "Le Bengué à portée de main",
    description:
      "Massages, accompagnement et prestations à domicile proposés par des annonceurs installés hors de Côte d'Ivoire.",
    target: "Membres qui voyagent ou vivent à l'étranger",
    pricing: "Abonnement premium",
    badge: "Nouveau & Exclusif",
    image: null,
    color: "#4C6EF5",
    colorSoft: "rgba(76,110,245,0.14)",
    number: "04",
  },
};

export const CITIES = ["Tous", "Abidjan", "Bouaké", "Yamoussoukro", "San-Pédro", "Korhogo", "Man", "Abengourou"];

export const AVATAR_GRADIENTS = [
  "linear-gradient(135deg, #E05638 0%, #D4AF37 100%)",
  "linear-gradient(135deg, #0A5C36 0%, #D4AF37 100%)",
  "linear-gradient(135deg, #D4AF37 0%, #E05638 100%)",
  "linear-gradient(135deg, #1C1917 0%, #E05638 100%)",
  "linear-gradient(135deg, #0A5C36 0%, #1C1917 100%)",
];
